import { type PasteTransformPlugin } from '@aha-app/aha-editor-v2';
import {
  duplicateWhiteboardRecord,
  insertEmbeddedWhiteboard,
  embeddedWhiteboardPlaceholder,
} from '../../WhiteboardUtils';
import { showAlertMessage } from 'javascripts/messages';

const EmbeddedWhiteboardPasteTransformer = {
  name: 'Embedded whiteboard paste transformer',
  pasteTransformer: {
    type: 'embedded-whiteboard',
    transform: (editor, controller, element, isMove) => {
      if (isMove) return element;

      const placeholder = embeddedWhiteboardPlaceholder();
      if (!controller.objectType || !controller.objectId) return;

      duplicateWhiteboardRecord({
        whiteboardId: element.whiteboard_id,
        objectType: controller.objectType,
        objectId: controller.objectId,
        baseURL: controller.baseURL,
        getSharingToken: controller.getSharingToken,
      })
        .then(res => {
          const {
            whiteboard: { id: whiteboardId },
          } = res;
          const placeholderId = placeholder.placeholder_id;
          insertEmbeddedWhiteboard({
            editor,
            currentElement: element,
            whiteboardId,
            placeholderId,
          });
        })
        .catch(err => {
          showAlertMessage(err);
          console.error(err);
        });

      return placeholder;
    },
  } as PasteTransformPlugin<'embedded-whiteboard'>,
};

export default EmbeddedWhiteboardPasteTransformer;
